import { Box, Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import { useTranslation } from "react-i18next";
const FormActions = ({ isDisabled = false, onClose }) =>
{
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 1,
            }}
        >
            <Button
                startIcon={<CheckIcon />}
                color="info"
                variant="contained"
                type="submit"
                name="submit"
                disabled={isDisabled}
            >
                {t("submit")}
            </Button>
            <Button
                startIcon={<CancelIcon />}
                color="error"
                variant="contained"
                type="button"
                name="cancel"
                onClick={onClose}
            >
                {t("cancel")}
            </Button>
        </Box>
    )
}

export default FormActions